"use client"

import { useTranslation } from "@/hooks/use-translation"

/**
 * WCAG skip link. A client component because its text is localized and
 * app/layout.tsx is a server component (it exports metadata), so the link
 * cannot read the language there. It still renders as the first element in the
 * body — the providers around it emit no DOM.
 */
export function SkipLink() {
  const { t } = useTranslation()
  return (
    <a className="skip-link" href="#main-content">
      {t("common.skipToMain")}
    </a>
  )
}
